import * as React from 'react';
import { Candidate } from '../../Model/Candidate';
import { NlToList } from '../NlToList';
import { Trans } from '../Trans';

export class AdditionalInformation extends React.PureComponent<{ candidate: Candidate }> {
    public render() {
        const additionalInformation = this.props.candidate.additionalInformation;
        if (!additionalInformation) {
            return null;
        }

        return <div className="additional-information location">
            <h3><Trans>Sonstiges</Trans></h3>
            <NlToList>{additionalInformation}</NlToList>
        </div>;
    }
}
